import type { ReactNode } from 'react';

interface Props {
  name: string;
  size?: number;
  stroke?: string;
}

export function NavIcon({ name, size = 18, stroke = 'currentColor' }: Props) {
  const paths: Record<string, ReactNode> = {
    brain: <path d="M9 4.5c-2 0-3.5 1.5-3.5 3.5 0 .8.3 1.5.7 2-.7.5-1.2 1.3-1.2 2.2 0 1.5 1.2 2.8 2.8 2.8h1.2v3M15 4.5c2 0 3.5 1.5 3.5 3.5 0 .8-.3 1.5-.7 2 .7.5 1.2 1.3 1.2 2.2 0 1.5-1.2 2.8-2.8 2.8H15v3M9 4.5v13M15 4.5v13M9 8.5h2M13 10.5h2" />,
    company: <path d="M3 19V8l5-3v14M8 19V11l9-3v11M12 13v3M14.5 13v3M11 16h8" />,
    spark: <path d="M12 3l1.8 5.4L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.6L12 3zM18 17l.6 2 2 .6-2 .6-.6 2-.6-2-2-.6 2-.6.6-2z" />,
    search: <><circle cx="10.5" cy="10.5" r="6" /><path d="M19 19l-4.2-4.2" /></>,
    sun: <><circle cx="12" cy="12" r="4" /><path d="M12 3v2M12 19v2M3 12h2M19 12h2M5.6 5.6l1.4 1.4M17 17l1.4 1.4M5.6 18.4L7 17M17 7l1.4-1.4" /></>,
    ticket: <path d="M3 9V6h18v3a2 2 0 100 4v3H3v-3a2 2 0 100-4zM12 6v12" />,
    doc: <path d="M5 3h9l5 5v13H5zM14 3v5h5" />,
    plug: <path d="M9 3v6M15 3v6M6 9h12v3a6 6 0 11-12 0V9zM12 18v3" />,
    lock: <path d="M7 11V8a5 5 0 0110 0v3M5 11h14v9H5z" />,
    bell: <path d="M6 16V11a6 6 0 1112 0v5l2 2H4l2-2zM10 21h4" />,
    plus: <path d="M12 5v14M5 12h14" />,
    chev: <path d="M7 9l5 5 5-5" />,
    grid: <><rect x="4" y="4" width="7" height="7" /><rect x="13" y="4" width="7" height="7" /><rect x="4" y="13" width="7" height="7" /><rect x="13" y="13" width="7" height="7" /></>,
    settings: <><circle cx="12" cy="12" r="3" /><path d="M19 12a7 7 0 00-.1-1.3l2-1.6-2-3.4-2.4.8a7 7 0 00-2.2-1.3L13.8 3h-3.6l-.5 2.4a7 7 0 00-2.2 1.3l-2.4-.8-2 3.4 2 1.6A7 7 0 005 12a7 7 0 00.1 1.3l-2 1.6 2 3.4 2.4-.8a7 7 0 002.2 1.3l.5 2.4h3.6l.5-2.4a7 7 0 002.2-1.3l2.4.8 2-3.4-2-1.6c.1-.4.1-.9.1-1.3z" /></>,
    star: <path d="M12 3l2.5 6.2 6.5.5-5 4.4 1.6 6.4L12 17l-5.6 3.5 1.6-6.4-5-4.4 6.5-.5L12 3z" />,
    inbox: <path d="M3 13l3-8h12l3 8v6H3zM3 13h5l1 2h6l1-2h5" />,
    eye: <><path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12z" /><circle cx="12" cy="12" r="3" /></>,
    arrow: <path d="M5 12h14M13 5l7 7-7 7" />,
    x: <path d="M18 6L6 18M6 6l12 12" />,
    logout: <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9" />,
  };

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {paths[name] ?? paths['doc']}
    </svg>
  );
}
